import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoseaddIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 10,
	viewBox: "0 0 14 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.53965 0.118164L6.0084 9.82066H6.68902L10.2203 0.118164H9.53965ZM2.84027 2.12004V4.68004H0.280273V5.32004H2.84027V7.88004H3.48027V5.32004H6.04027V4.68004H3.48027V2.12004H2.84027ZM10.2003 4.68004V5.32004H13.7203V4.68004H10.2003Z",
		className: "icons-color"
	})]
});
const ForwardRef = forwardRef(SvgDoseaddIcon);
export default ForwardRef;
